import React, { createContext, useContext } from 'react';
import { useAuth, User, AnonymousProgress } from '../hooks/useAuth';
interface AppContextType {
  user: User | null;
  anonymousProgress: AnonymousProgress;
  showSaveProgressPrompt: boolean;
  setShowSaveProgressPrompt: (show: boolean) => void;
  signIn: (email: string, name: string) => void;
  signOut: () => void;
  updateUser: (updates: Partial<User>) => void;
  updateAnonymousProgress: (updates: Partial<AnonymousProgress>) => void;
  addDiamonds: (amount: number) => void;
  spendDiamonds: (amount: number) => boolean;
  isAuthenticated: boolean;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
export function AppProvider({
  children
}: {
  children: ReactNode;
}) {
  const auth = useAuth();
  return <AppContext.Provider value={auth} data-id="element-711">{children}</AppContext.Provider>;
}
export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
}